module.exports = __webpack_public_path__ + "img/preset1.0a4c508d.png";